document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-lazy-image]").forEach((image) => {
        const loadImage = () => {
            image.src = image.dataset.src;
            image.srcset = image.dataset.srcset;
            image.removeAttribute("data-lazy-image");
        };

        if (!("IntersectionObserver" in window)) {
            loadImage();
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
                return;
            }

            loadImage();
            observer.disconnect();
        }, { rootMargin: "0px" });

        observer.observe(image);
    });
});